import React, {
  useEffect,
  useState,
  useCallback,
  useRef, useMemo,
  ChangeEvent
} from "react";
import "./User.scss";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Image,
  Row,
} from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Billing from "./Billing/Billing";
import Places from "./Places/Places";
import Cart from "../Cart/Cart";
import { CartData } from "../../interfaces/CartData";
import Payment from "./Payment/Payment";
import { useCart } from "../../services/cartService";
import { useHeaderMenu, writeLoginSession } from "../../contexts/login.context";
import useLoader from "../../contexts/LoaderContext";
import cartLoader from "../../assets/images/cart_Loader.gif";
import { useTranslation } from "react-i18next";
import { FaPlus } from "react-icons/fa6";
import { config } from "../../config";
import { initialize } from "@nv-ces/ucp-wrapper";
import { v4 as uuidv4 } from "uuid";
import * as validate from "./helper";
import { PaymentEvents } from "./constants";
import * as intrfce from "./Interfaces";
import { useLocalization } from "../../contexts/LocalizationContext";
import BillingJapan from "./Billing/BillingJapan";
import PlacesJapan from "./Places/PlacesJapan";
import { jwtDecode } from "jwt-decode";
import { isJwtTokenExpired, resolveCompanyNameFromCart } from "../../helpers/common";
import { BusinessPurchaseSection } from './sections/BusinessPurchaseSection';
import { taxExemptionLocales, ucpTaxExemptionLocales, shouldShowBillingCompanyName } from "../../constants/taxExemptionLocales";
import { useGuestAccessToken } from "../../hooks/useGuestAccessToken";
import { buildUcpOptions, getUcpEnvironment } from "../../services/ucpOptions";
import { isRegisteredCheckout } from "../../helpers/checkoutAuth";
import BillingAddressValidationModal from "./AddressModal/BillingAddressValidationModal";
import {
  AddressSelection,
  canConfirmEnteredBillingAddress,
  createBillingAddressValidationPayload,
  getBillingAddressValidationOutcome,
  getBillingAddressValidationKey,
  getRecommendedBillingAddress,
  invalidateBillingAddressConfirmation,
  isBillingAddressValidationUnavailable,
  isRecommendedBillingAddressValid,
} from "./utils/billingAddressValidation";


const User = () => {
  const { userType } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const RESET_ADDRESS = "reset";
  const queryParams = new URLSearchParams(useLocation().search);
  const orderState = queryParams.get("order");
  const isDownload: boolean = false;
  const isVerify: boolean = false;
  const isThanks: boolean = false;
  const [selectedBillingAddress, setSelectedBillingAddress] = useState<intrfce.iSavedAddress | null | typeof RESET_ADDRESS>(null);
  const [savedBillingAddress, setSavedBillingAddress] = useState<intrfce.iSavedAddress[]>([]);
  const [isBillingReadonly, setIsBillingReadonly] = useState(false);
  const [couponCode, setCoupon] = useState<string | null>(null);
  const futureUse = true;
  const [cartData, setCartData] = useState<CartData | undefined>();
  const isLoggedIn = isRegisteredCheckout(userType, cartData?.idt);
  const checkoutUserType = isLoggedIn ? "loggedIn" : "guest";
  const [validationErrors, setValidationErrors] = useState<Record<string, string>>({});
  const [enableReviewOrderBtn, setEnableReviewOrderBtn] =
    useState<boolean>(false);
  const {
    showBodyLoader,
    hideBodyLoader,
    isCartLoading,
    hideCartLoader,
    showCartLoader,
  } = useLoader();
  const [promoErr, setPromoErr] = useState<boolean>(false);
  const [addressErr, setAddressErr] = useState<null | string>(null);
  const [savePayment, setSavePayment] = useState(false);
  const [submitAfterSavePayment, setSubmitAfterSavePayment] = useState(false);
  const { locale, localeWith_, stateDropdown, countryList, countryListPhysical, countyField, defaultCurrency, postalCodeRequired } = useLocalization();
  const {
    setItemsInCart,
    setOrder,
    isDownload: isDigitalProduct,
    setIsDownload,
    setCartCategory,
    cartCategory,
    brand,
    setBrand,
    setDeviceFingerprintUuid,
    setLoginStatus
  } = useHeaderMenu();
  const [paymentEventMessage, setPaymentEventMessage] = useState<string | null>(
    null
  );
  const [isPurchasingForSomeoneElse, setIsPurchasingForSomeoneElse] = useState(false);
  const [isPurchasingDisabled, setIsPurchasingDisabled] = useState(false);
  const [conflictingCourseIds, setConflictingCourseIds] = useState<string[]>([]);
  const [formTaxData, setFormTaxData] = useState<intrfce.iTaxFormData>({
    companyName: "",
    vatNo: "",
  });
  const [isBusinessPurchase, setIsBusinessPurchase] = useState(false);
  const countries = useMemo(() => {
    return (isDigitalProduct ? countryList : (countryListPhysical || countryList));
  }, [isDigitalProduct, countryList, countryListPhysical])

  if (userType) {
    sessionStorage.setItem("customer", userType);
  } else {
    // Handle the case when userType is undefined
    navigate(`/${locale}/software/cart/`);
  }

  const handleLogin = () => {
    window.location.href = `${config.bcSSOLoginUrl}${locale}/software/cart`;

  };

  const reviewOrder = (user: string) => {
    navigate(`/${locale}/software/cart/verify`, { state: { user, validationErrors: validationErrors as any, cartCategory } });
  };

  const emptyCart = (msg: string, pid?: number, errorObj?: any) => {
    navigate(`/${locale}/software/cart/empty`, { state: { msg, pid, cartCategory, error: errorObj } });
  };

  const [formBillingAddress, setFormBillingAddress] =
    useState<intrfce.iAddressFormData>({
      pincode: "",
      address: "",
      line2: '',
      cityValue: "",
      stateValue: locale === 'zh-tw' ? "TW" : "",
      countryName: countries[0].countryName,
      countryValue: countries[0].ISO_CC,
    });
  const [showBillingAddressModal, setShowBillingAddressModal] = useState(false);
  const [recommendedBillingAddress, setRecommendedBillingAddress] =
    useState<intrfce.iAddressFormData | null>(null);
  const [billingAddressOverride, setBillingAddressOverride] =
    useState<intrfce.iAddressFormData | null>(null);
  const [selectedBillingAddressOption, setSelectedBillingAddressOption] =
    useState<AddressSelection>("yourAddress");
  const [isOriginalBillingAddressValid, setIsOriginalBillingAddressValid] =
    useState(false);
  const [
    billingAddressValidationUnavailable,
    setBillingAddressValidationUnavailable,
  ] = useState(false);
  const [isAddressValidating, setIsAddressValidating] = useState(false);
  const [confirmedBillingAddressKey, setConfirmedBillingAddressKey] =
    useState<string | null>(null);
  const currentBillingAddressKey =
    getBillingAddressValidationKey(formBillingAddress);
  const isBillingAddressConfirmed =
    confirmedBillingAddressKey === currentBillingAddressKey;
  const isPostalCodeRequiredForAddress =
    postalCodeRequired &&
    !(locale === "es-la" && formBillingAddress.countryValue === "PA");
  const isStateRequiredForAddress =
    stateDropdown &&
    locale !== "en-me" &&
    !(locale === "es-la" && formBillingAddress.countryValue === "PA");

  // An edit permanently invalidates the previous confirmation, even if the
  // user later changes the fields back to their earlier values.
  useEffect(() => {
    setConfirmedBillingAddressKey((confirmedKey) =>
      invalidateBillingAddressConfirmation(
        confirmedKey,
        currentBillingAddressKey
      )
    );
  }, [currentBillingAddressKey]);

  const [formBillingData, setFormBillingData] =
    useState<intrfce.iBillingFormData>({
      firstNameBilling: "",
      lastNameBilling: "",
      contactBilling: "",
      emailBilling: "",
      vemailBilling: "",
    });
  const isUcpTaxExemptionLocale = ucpTaxExemptionLocales.includes(locale);
  const isApTaxExemptionLocale = taxExemptionLocales.includes(locale);
  const showBillingCompanyName = shouldShowBillingCompanyName(locale);
  const [formData, setFormData] = useState<intrfce.iFormContainer>({
    iBillingFormData: formBillingData,
    iBillingFormAddress: formBillingAddress,
  });

  const isTaxDataValid = useCallback((): boolean => {
    if (isApTaxExemptionLocale && isBusinessPurchase) {
      if (!formTaxData.companyName?.trim()) {
        return false;
      }
      if (validationErrors.companyName || validationErrors.vatNo) {
        return false;
      }
    }

    if (showBillingCompanyName && validationErrors.companyName) {
      return false;
    }

    return true;
  }, [isApTaxExemptionLocale, isBusinessPurchase, formTaxData.companyName, validationErrors.companyName, validationErrors.vatNo, showBillingCompanyName]);

  // en-ap only: validate company name and VAT when business purchase is checked
  useEffect(() => {
    if (!isApTaxExemptionLocale) {
      return;
    }

    if (!isBusinessPurchase) {
      setValidationErrors((prev) => ({
        ...prev,
        companyName: '',
        vatNo: '',
      }));
      return;
    }

    let companyNameError = '';
    let vatNoError = '';

    if (!formTaxData.companyName || formTaxData.companyName.trim() === '') {
      companyNameError = t("COMPANY_NAME_REQUIRED");
    }

    if (formTaxData.companyName && formTaxData.companyName.trim() !== '') {
      if (!formTaxData.vatNo || formTaxData.vatNo.trim() === '') {
        vatNoError = t("VAT_NUMBER_REQUIRED");
      }
    }

    setValidationErrors((prev) => ({
      ...prev,
      companyName: companyNameError,
      vatNo: vatNoError,
    }));
  }, [formTaxData.companyName, formTaxData.vatNo, isBusinessPurchase, isApTaxExemptionLocale, t]);

  useEffect(() => {
    if (showBillingCompanyName && !formTaxData.companyName?.trim()) {
      setValidationErrors((prev) => ({
        ...prev,
        companyName: '',
      }));
    }
  }, [formTaxData.companyName, showBillingCompanyName]);

  const handleisBusinessPurchaseChange = useCallback((e: ChangeEvent<HTMLElement> | React.MouseEvent<HTMLButtonElement>) => {
    setIsBusinessPurchase(!isBusinessPurchase);
    setFormTaxData({
      companyName: '',
      vatNo: '',
    });
  }, [isBusinessPurchase]);

  const populateFormTaxDataFromCart = useCallback((
    cart: {
      taxExemption?: { companyName?: string | null; vatNo?: string | null } | null;
      billingAddress?: { companyName?: string | null } | null;
    }
  ) => {
    const companyName = resolveCompanyNameFromCart(cart);
    const vatNo = cart.taxExemption?.vatNo?.trim() || '';

    if (isApTaxExemptionLocale) {
      if (companyName || vatNo) {
        setFormTaxData({
          companyName: companyName || '',
          vatNo: vatNo || '',
        });
        setIsBusinessPurchase(true);
      }
      return;
    }

    if (showBillingCompanyName && companyName) {
      setFormTaxData({
        companyName,
        vatNo: '',
      });
    }
  }, [isApTaxExemptionLocale, showBillingCompanyName]);

  /**
   * Validates VAT number (conditional based on company name)
   */
  const validateVatNumber = (
    value: string,
    companyName: string,
    isEmpty: string
  ): string => {
    if (companyName && companyName.trim() !== '') {
      if (!value || value.trim() === '') {
        return isEmpty;
      }
    }
    return '';
  };

  const validateForm = useCallback(
    (
      fieldName: string,
      value: string | {} | boolean,
    ): boolean => {
      let error = "";
      switch (fieldName) {
        case "firstNameBilling":
          if (
            !formBillingData.firstNameBilling ||
            formBillingData.firstNameBilling.trim() === ""
          ) {
            error = t("FIRST_NAME_EMPTY");
          } else if (
            !validate.validateInput(formBillingData.firstNameBilling)
          ) {
            error = t("FIRST_NAME_INVALID");
          }
          break;
        case "lastNameBilling":
          if (
            !formBillingData.lastNameBilling ||
            formBillingData.lastNameBilling.trim() === ""
          ) {
            error = t("LAST_NAME_EMPTY");
          } else if (!validate.validateInput(formBillingData.lastNameBilling)) {
            error = t("LAST_NAME_INVALID");
          }
          break;
        case "emailBilling":
          if (isLoggedIn) {
            if (
              !formBillingData.emailBilling ||
              formBillingData.emailBilling.trim() === ""
            ) {
              error = t("EMAIL_ADDRESS_EMPTY");
            } else if (!validate.validateEmail(formBillingData.emailBilling)) {
              error = t("EMAIL_ADDRESS_INVALID");
            }
          }
          break;
        case "vemailBilling":
          if (!isLoggedIn) {
            if (
              !formBillingData.vemailBilling ||
              formBillingData.vemailBilling.trim() === ""
            ) {
              error = t("EMAIL_ADDRESS_EMPTY");
            } else if (!validate.validateEmail(formBillingData.vemailBilling)) {
              error = t("EMAIL_ADDRESS_INVALID");
            } else if (
              formBillingData.vemailBilling !== formBillingData.emailBilling
            ) {
              error = t("EMAIL_ADDRESS_MISMATCH");
            }
          }
          break;
        case "contactBilling":
          if (
            !formBillingData.contactBilling ||
            formBillingData.contactBilling.trim() === ""
          ) {
            error = t("CONTACT_NUMBER_EMPTY");
          } else if (
            !validate.validateContactNumber(formBillingData.contactBilling, locale, formBillingAddress.countryValue)
          ) {
            error = t("CONTACT_NUMBER_INVALID");
          }
          break;
        case "pincode":
          if (isPostalCodeRequiredForAddress) {
            if (!value || (value as string).trim() === "") {
              error = t("ZIP_CODE_EMPTY");
            } else if (!validate.validatePostalCodes(value as string, locale, formBillingAddress.countryValue)) {
              error = t("ZIP_CODE_INVALID");
            }
          }
          break;
        case "address":
          if (!value || (value as string).trim() === "") {
            error = t("ADDRESS_REQUIRED");
          } else if (
            !validate.validateStringOrIntegerAddress(value as string, locale)
          ) {
            error = t("ADDRESS_INVALID");
          } else {
            if (!validate.validateAddress(value as string)) {
              error = t("ADDRESS_PO_BOX");
            }
          }
          break;
        case "cityValue":
          if (!value || (value as string).trim() === "") {
            error = t("CITY_REQUIRED");
          } else if (
            !value
          ) {
            error = t("CITY_INVALID");
          }
          break;
        case "stateValue":
          if (isStateRequiredForAddress) {
            if (!value || (value as string).trim() === "") {
              error = t("STATE_EMPTY");
            } else if (!validate.validateInput(value as string)) {
              error = t("STATE_INVALID");
            }
          }
          break;
        default:
          break;
      }
      // Validation logic for billing fields
      switch (fieldName) {
        case "cityBilling":
          if (!value || (value as string).trim() === "") {
            error = t("CITY_REQUIRED");
          } else if (
            !value
          ) {
            error = t("CITY_INVALID");
          }
          break;
        case "stateNameBilling":
          if (!value || (value as string).trim() === "") {
            error = t("STATE_EMPTY");
          } else if (!validate.validateInput(value as string)) {
            error = t("STATE_INVALID");
          }
          break;
        case "zipBilling":
          if (!value || (value as string).trim() === "") {
            error = t("ZIP_CODE_EMPTY");
          } else if (!validate.validatePostalCodes(value as string, locale, formBillingAddress.countryValue)) {
            error = t("ZIP_CODE_INVALID");
          }
          break;
        case "countryBilling":
          if (!value || (value as string).trim() === "") {
            error = t("COUNTRY_REQUIRED");
          } else if (!validate.validateInput(value as string)) {
            error = t("COUNTRY_INVALID");
          }
          break;
        case "addressBilling":
          if (!value || (value as string).trim() === "") {
            error = t("ADDRESS_REQUIRED");
          } else if (
            !validate.validateStringOrIntegerAddress(value as string, locale)
          ) {
            error = t("ADDRESS_INVALID");
          } else {
            if (!validate.validateAddress(value as string)) {
              error = t("ADDRESS_PO_BOX");
            }
          }
          break;
        case "companyName":
          if (showBillingCompanyName) {
            if (value && (value as string).trim() !== "" && !validate.validateInput(value as string)) {
              error = t("COMPANY_NAME_REQUIRED");
            }
          } else if (isApTaxExemptionLocale && isBusinessPurchase) {
            if (!value || (value as string).trim() === "") {
              error = t("COMPANY_NAME_REQUIRED");
            }
          }
          break;

        case "vatNo":
          if (isApTaxExemptionLocale && isBusinessPurchase) {
            error = validateVatNumber(
              value as string,
              formTaxData.companyName,
              t("VAT_NUMBER_REQUIRED")
            );
          }
          break;
        default:
          break;
      }

      const errors: Record<string, string> = { [fieldName]: error };
      if (
        fieldName === "pincode" ||
        fieldName === "address" ||
        fieldName === "cityValue" ||
        fieldName === "stateValue"
      ) {
        let errorFieldName = fieldName;
        setValidationErrors((prevErrors) => ({
          ...prevErrors,
          [errorFieldName]: error,
        }));
      }
      if (fieldName !== "promoCode") {
        setValidationErrors((prevErrors) => ({
          ...prevErrors,
          [fieldName]: error,
        }));
      }
      return errors[fieldName].length === 0;
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [formData, formBillingData, formBillingAddress, setValidationErrors, locale, t, isLoggedIn, formTaxData, showBillingCompanyName, isApTaxExemptionLocale, isBusinessPurchase, isPostalCodeRequiredForAddress, isStateRequiredForAddress]
  );
  const orderAccount = () => {
    window.location.href = config.bcOrdersUrl;
  };
  const isEmptyString = (value: any) => {
    return (
      value === undefined || (typeof value === "string" && value.trim() === "")
    );
  };

  const isObjectEmpty = (obj: any) => {
    if (obj === null || obj === undefined || typeof obj !== "object") {
      return isEmptyString(obj);
    }
    return Object.values(obj).every(value => value === null || value === "" || value === undefined);
  };
  const isBillingAddressValid = (): boolean => {
    // First check if the address has any fields other than countryName and countryValue
    const hasOtherFields = Object.entries(formBillingAddress).some(
      ([key, value]) => {
        // Skip metadata fields and optional state values in the check.
        if (
          key === "countryName" ||
          key === "countryValue" ||
          (key === "stateValue" && !isStateRequiredForAddress)
        ) {
          return false;
        }
        return !isEmptyString(value);
      }
    );

    if (!hasOtherFields) {
      return false;
    }

    // Now validate all fields if other fields are present
    if (!isObjectEmpty(formBillingAddress)) {
      for (const [fieldName, value] of Object.entries(formBillingAddress)) {
        if (fieldName === "stateValue" && !isStateRequiredForAddress) {
          continue;
        }
        const fieldIsValid = validateForm(fieldName, value);
        if (fieldIsValid) {
          console.log("isBillingAddressValid==>", validationErrors[fieldName]);
        } else {
          console.table(validationErrors);
          return false; // Exit the function immediately if any field is invalid
        }
      }
      return true; // All fields are valid
    }
    return false;
  };
  const isBillingFormValid = (): boolean => {
    for (const [fieldName, value] of Object.entries(formBillingData)) {
      const fieldIsValid = validateForm(fieldName, value);
      if (fieldIsValid) {
        console.log("isformBillingDataValid==>", formBillingData[fieldName]);
      } else {
        console.log(
          "validateionErrors isformBillingDataValid==>",
          validationErrors[fieldName],
          formBillingData[fieldName]
        );
        return false; // Exit the function immediately if any field is invalid
      }
    }
    return true; // All fields are valid
  };
  // Define success and error callback functions
  const handleSuccess = async (result, pid?) => {
    const locale = window.location.pathname.split("/")[1]; // Extract 'en-us'
    let cartState = result?.cartItems?.cartItem;
    const isResultLoggedIn = Boolean(result?.idt);
    setLoginStatus(isResultLoggedIn);
    setIsDownload(result.isDigital);
    setCartCategory(result.category?.toUpperCase() ?? '');
    setBrand(result?.brand?.toUpperCase());
    setIsPurchasingForSomeoneElse(result.isPurchasingForSomeoneElse);
    populateFormTaxDataFromCart(result);

    if (cartState && cartState.length > 0) {
      const items = cartState.map((cartItem: any) => ({
        quantity: cartItem.quantity,
        price: {
          basePrice: parseFloat(
            String(cartItem?.pricing?.formattedListPrice ?? "").replace(/[^\d.]/g, "")
          ) || 0, // Convert to number
          discount: 0, // Assuming no discount information is present
        },
        productInfo: {
          sku: `sku-${cartItem.product.id}`, // Generate SKU from product ID if no SKU exists
          prodID: cartItem.product.id.toString(),
          productName: cartItem.product.name,
        },
      }));

      const formattedLocale = locale
        .replace("-", "_")
        .toLowerCase()
        .replace(/^[a-z]{2}/, (match) => match.toUpperCase());
      const cart = {
        customerID: "",
        orderID: result ? result["cartId"] : "",
        currencyCode: result ? result["pricing"]["orderTotal"]["currency"] : "",
        loginState: isResultLoggedIn ? "loggedIn" : "guest",
        storeLocale: formattedLocale,
        promoCode: "no",
        items: items,
      };
      if (typeof window !== "undefined") {
        (window as any).CartOrder = cart;
      }
    } else {
      emptyCart(t("YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY"));
    }
    console.log((window as any).CartOrder);
    if (result.totalItemsInCart) {
      let billing = result?.billingAddress;
      setCartData(result);
      setItemsInCart(result.totalItemsInCart);

      // Use result directly instead of cartData state
      if (result.totalItemsInCart > 0) {
        if (isResultLoggedIn) {
          const token = result.idt;
          const decoded = jwtDecode(token);
          console.log('idToken decoded===>', decoded);
          const timestamp = decoded['updated_at']; // seconds
          const date = new Date(timestamp * 1000);
          const timestampISO = date.toISOString();
          const writeSession = await writeLoginSession(decoded['email'], decoded['idp_id'], timestampISO, decoded['sub'] || '');
          console.log('writeSession===>', writeSession);
          console.log('writeSession called');
          navigate(`/${locale}/software/cart/user/loggedIn`);
        } else {
          navigate(`/${locale}/software/cart/user/guest`);
        }
      } else {
        emptyCart(t("YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY"));
      }

      if (!cartState || cartState.length === 0) {
        if (isResultLoggedIn) {
          orderAccount();
        } else {
          handleError("", pid);
        }
      }
      if (isResultLoggedIn) {
        if (savedBillingAddress && !savedBillingAddress?.length) {
          const addresses = result["addresses"];
          if (addresses?.length && !addresses.some((addr) => addr.isDefault)) {
            addresses[0].isDefault = true;
          }
          setSavedBillingAddress(addresses);
        }
        setFormBillingData((prevData) => ({
          ...prevData,
          emailBilling: result?.emailAddress
            ? result?.emailAddress
            : result?.billingAddress[0]?.emailAddress || "",
        }));
      }

      if (result?.billingAddress) {
        const billingData = formFieldsRef.current.billing.data;
        const billingAddress = formFieldsRef.current.billing.address;
        setFormBillingData({
          ...(billing.id ? { id: Number(billing.id) } : {}),
          firstNameBilling: billing.firstName || billingData?.firstNameBilling,
          lastNameBilling: billing.lastName || billingData?.lastNameBilling,
          contactBilling: billing.phoneNumber || billingData?.contactBilling,
          emailBilling: billing.emailAddress || result?.emailAddress || billingData?.emailBilling,
          vemailBilling: billing.emailAddress || result?.emailAddress || billingData?.vemailBilling,
        });
        setFormBillingAddress({
          pincode: billing.postalCode || billingAddress?.pincode,
          address: billing.line1 || billingAddress?.address,
          cityValue: billing.city || billingAddress?.cityValue,
          stateValue:
            (stateDropdown || locale === 'zh-tw') ? (locale === 'zh-tw' ? "TW" : (billing.countrySubdivision || billingAddress?.stateValue)) : billingAddress?.stateValue,
          county: countyField ? billing.county || billingAddress?.county : undefined,
          countryName: billing.countryName || billingAddress?.countryName,
          countryValue: billing.country || billingAddress?.countryValue,
        });
        // Set selected address for billing
        setSelectedBillingAddress({
          ...(billing.id ? { id: Number(billing.id) } : {}),
          city: billing.city || billingAddress?.cityValue,
          countryName: billing.countryName || billingAddress?.countryName,
          country: billing.country || billingAddress?.countryValue,
          firstName: billing.firstName || billingData?.firstNameBilling,
          lastName: billing.lastName || billingData?.lastNameBilling,
          line1: billing.line1 || billingAddress?.address,
          line2: null,
          nickName: "",
          phoneNumber: billing.phoneNumber || billingData?.contactBilling,
          postalCode: billing.postalCode || billingAddress?.pincode,
          countrySubdivision:
            (stateDropdown || locale === 'zh-tw') ? (locale === 'zh-tw' ? "TW" : (billing.countrySubdivision || billingAddress?.stateValue)) : billingAddress?.stateValue,
          county: countyField ? billing.county || billingAddress?.county : undefined,
        });
        if (Number(billing.id) > -1) {
          if (isResultLoggedIn && savedBillingAddress.length) {
            setIsBillingReadonly(true);
          } else {
            setIsBillingReadonly(false);
          }
        }
      }

      // Check if any product has multiple quantity
      if (cartState && cartState.length > 0) {
        const hasMultipleQuantity = cartState.some((item: any) => item.quantity > 1);

        if (hasMultipleQuantity) {
          // Clear the enrollment error when quantity is changed to multiple
          if (validationErrors?.enrollmentErr) {
            setValidationErrors((prevErrors) => {
              const { enrollmentErr, ...rest } = prevErrors;
              return rest;
            });
          }

          // Set isPurchasingForSomeoneElse to true and disable the checkbox
          setIsPurchasingForSomeoneElse(true);
          setIsPurchasingDisabled(true);
        } else if (!hasMultipleQuantity && isPurchasingDisabled) {
          // Re-enable the checkbox if quantity is back to 1
          setIsPurchasingDisabled(false);
        }
      }

      hideBodyLoader();
    } else {
      if (isResultLoggedIn) {
        orderAccount();
      } else {
        handleError("", pid);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };
  const handleCartUpdateSuccess = async (result, pid?) => {
    const locale = window.location.pathname.split("/")[1]; // Extract 'en-us'
    let cartState = result?.cartItems?.cartItem;
    const isResultLoggedIn = Boolean(result?.idt);
    setLoginStatus(isResultLoggedIn);
    setIsDownload(result.isDigital);
    setCartCategory(result.category?.toUpperCase() ?? '');
    setBrand(result?.brand?.toUpperCase());
    populateFormTaxDataFromCart(result);

    if (cartState && cartState.length > 0) {
      const items = cartState.map((cartItem) => ({
        quantity: cartItem.quantity,
        price: {
          basePrice: parseFloat(
            String(cartItem?.pricing?.formattedListPrice ?? "").replace(/[^\d.]/g, "")
          ) || 0, // Convert to number
          discount: 0, // Assuming no discount information is present
        },
        productInfo: {
          sku: `sku-${cartItem.product.id}`, // Generate SKU from product ID if no SKU exists
          prodID: cartItem.product.id.toString(),
          productName: cartItem.product.name,
        },
      }));

      const formattedLocale = locale
        .replace("-", "_")
        .toLowerCase()
        .replace(/^[a-z]{2}/, (match) => match.toUpperCase());
      const cart = {
        customerID: "",
        orderID: result ? result["cartId"] : "",
        currencyCode: result ? result["pricing"]["orderTotal"]["currency"] : "",
        loginState: isResultLoggedIn ? "loggedIn" : "guest",
        storeLocale: formattedLocale,
        promoCode: "no",
        items: items,
      };
      if (typeof window !== "undefined") {
        (window as any).CartOrder = cart;
      }
    } else {
      emptyCart(t("YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY"));
    }
    console.log((window as any).CartOrder);
    if (result.totalItemsInCart) {
      setCartData(result);
      setItemsInCart(result.totalItemsInCart);

      // Use result directly instead of cartData state
      if (result.totalItemsInCart > 0) {
        if (isResultLoggedIn) {
          const token = result.idt;
          const decoded = jwtDecode(token);
          console.log('idToken decoded===>', decoded);
          const timestamp = decoded['updated_at']; // seconds
          const date = new Date(timestamp * 1000);
          const timestampISO = date.toISOString();
          const writeSession = await writeLoginSession(decoded['email'], decoded['idp_id'], timestampISO, decoded['sub'] || '');
          console.log('writeSession===>', writeSession);
          console.log('writeSession called');
          navigate(`/${locale}/software/cart/user/loggedIn`);
        } else {
          navigate(`/${locale}/software/cart/user/guest`);
        }
      } else {
        emptyCart(t("YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY"));
      }

      if (!cartState || cartState.length === 0) {
        if (isResultLoggedIn) {
          orderAccount();
        } else {
          handleError("", pid);
        }
      }

      // Check if any product has multiple quantity
      if (cartState && cartState.length > 0) {
        const hasMultipleQuantity = cartState.some((item: any) => item.quantity > 1);

        if (hasMultipleQuantity) {
          // Clear the enrollment error when quantity is changed to multiple
          if (validationErrors?.enrollmentErr) {
            setValidationErrors((prevErrors) => {
              const { enrollmentErr, ...rest } = prevErrors;
              return rest;
            });
          }

          // Set isPurchasingForSomeoneElse to true and disable the checkbox
          setIsPurchasingForSomeoneElse(true);
          setIsPurchasingDisabled(true);

          // Enable review order button for multiple quantities or zero dollar transactions (with form validation)
          const isZeroDollarTransaction = result?.zdt || result?.pricing?.orderTotal?.value === 0;
          if (isZeroDollarTransaction) {
            setEnableReviewOrderBtn(false);
          } else {
            setEnableReviewOrderBtn(true);
          }
        } else if (!hasMultipleQuantity && isPurchasingDisabled) {
          // Re-enable the checkbox if quantity is back to 1
          setIsPurchasingDisabled(false);
        }
      }

      // Check if this is a zero dollar transaction and validate form
      const isZeroDollarTransaction = result?.zdt || result?.pricing?.orderTotal?.value === 0;
      if (isZeroDollarTransaction) {
        setEnableReviewOrderBtn(false);
      }

      hideBodyLoader();
    } else {
      if (isResultLoggedIn) {
        orderAccount();
      } else {
        handleError("", pid);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  const handleError = (str: string, pid?: number) => {
    if (pid) {
      if (str && str.length) {
        emptyCart(str, pid);
      } else {
        emptyCart(t("YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY"), pid);
      }
    } else {
      emptyCart(t("YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY"));
    }
    setItemsInCart(0);
    hideBodyLoader();
  };
  const handleCouponError = (str: string) => {
    if (str && str.length) {
      emptyCart(str);
    }
    if (couponCode && couponCode.length >= 0) {
      setPromoErr(true);
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        promoCode: t("INVALID_PROMO"),
      }));
    } else if (!couponCode) {
      setPromoErr(true);
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        promoCode: t("INVALID_PROMO"),
      }));
    } else {
      setPromoErr(false);
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        promoCode: "",
      }));
    }
    hideBodyLoader();
  };
  const { getCart, updateCart, submitCart, submitAddress, mintGuestAccessToken } =
    useCart();

  const fetchCart = async () => {
    showBodyLoader();
    await getCart(handleSuccess, handleError);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  useEffect(() => {
    if (orderState) {
      fetchCart();
      hideBodyLoader();
    } else {
      if (cartData) {
        const parsedFormData = cartData;
        showBodyLoader();
        populateFormTaxDataFromCart(parsedFormData);

        if (parsedFormData?.billingAddress) {
          let billing = parsedFormData?.billingAddress;
          if (Number(billing.id)) {
            handleSavedBillingAddressChange("savedBillingAddress", "reset");
            setFormBillingData({
              ...(billing.id ? { id: Number(billing.id) } : {}),
              firstNameBilling: billing.firstName || "",
              lastNameBilling: billing.lastName || "",
              contactBilling: billing.phoneNumber || "",
              emailBilling: billing.emailAddress || "",
              vemailBilling: billing.emailAddress || "",
            });
            setFormBillingAddress({
              pincode: billing.postalCode || "",
              address: billing.line1 || "",
              line2: billing.line2 || "",
              cityValue: billing.city || "",
              stateValue:
                (stateDropdown || locale === 'zh-tw')
                  ? (locale === 'zh-tw' ? "TW" : billing.countrySubdivision)
                  : undefined,
              county: countyField ? billing.county || "" : undefined,
              countryName: billing.countryName,
              countryValue: billing.country,
            });
            // Set selected address for billing
            setSelectedBillingAddress({
              city: billing.city || "",
              countryName: billing.countryName,
              country: billing.country,
              firstName: billing.firstName || "",
              lastName: billing.lastName || "",
              line1: billing.line1 || "",
              line2: billing.line2,
              nickName: "",
              phoneNumber: billing.phoneNumber || "",
              postalCode: billing.postalCode || "",
              countrySubdivision: billing.countrySubdivision,
              ...(countyField && { county: billing.county }),
            });
          }
        }
        if (parsedFormData.billingAddress) {
          let billing = parsedFormData.billingAddress;
          setFormData({
            iBillingFormData: {
              ...(billing.id ? { id: Number(billing.id) } : {}),
              firstNameBilling: billing?.firstName,
              lastNameBilling: billing?.lastName,
              contactBilling: billing?.phoneNumber,
              emailBilling: billing?.emailAddress,
              vemailBilling: billing?.emailAddress,
            },
            iBillingFormAddress: {
              pincode: billing?.postalCode || "",
              address: billing?.line1 || "",
              line2: billing?.line2 || "",
              cityValue: billing?.city || "",
              stateValue:
                (stateDropdown || locale === 'zh-tw')
                  ? (locale === 'zh-tw' ? "TW" : billing?.countrySubdivision)
                  : undefined,
              county: countyField ? billing?.county || "" : undefined,
              countryValue: billing?.country || "",
              countryName: billing?.countryName || "",
            }
          });
        }
      } else if (!cartData) {
        fetchCart();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleBillingInputChange = (
    fieldName: string,
    value: string | boolean
  ) => {
    setFormBillingData((prevData) => ({ ...prevData, [fieldName]: value }));
  };
  const handleBillingInputBlur = (
    fieldName: string,
    value: string | boolean
  ) => {
    validateForm(fieldName, value);
  };

  const isPaymentRequired = Boolean(
    cartData &&
    !cartData.zdt &&
    cartData.pricing?.orderTotal?.value !== 0
  );
  const guestEmail =
    formBillingData.emailBilling?.trim() ||
    cartData?.emailAddress?.trim() ||
    cartData?.billingAddress?.emailAddress?.trim() ||
    "";
  const {
    token: guestAccessToken,
    error: guestTokenError,
    handleUcpGlobalEvent,
  } = useGuestAccessToken({
    enabled:
      isBillingAddressConfirmed && !isLoggedIn && isPaymentRequired,
    email: guestEmail,
    mintToken: mintGuestAccessToken,
  });
  const [guestUcpInitializationError, setGuestUcpInitializationError] =
    useState(false);
  const [guestUcpReady, setGuestUcpReady] = useState(false);
  const guestPaymentUnavailable =
    isBillingAddressConfirmed &&
    !isLoggedIn &&
    isPaymentRequired &&
    (guestTokenError ||
      guestUcpInitializationError ||
      !guestAccessToken ||
      !guestUcpReady);

  // Create refs to store form field values
  const formFieldsRef = useRef<{
    billing: {
      address: intrfce.iAddressFormData | null;
      data: intrfce.iBillingFormData | null;
    };
  }>({
    billing: {
      address: null,
      data: null,
    }
  });

  // Monitor page visibility to detect when page becomes active again
  useEffect(() => {
    const handleVisibilityChange = () => {
      // Guest carts can retain a stale idt after logout; only inspect registered sessions.
      if (!document.hidden && isLoggedIn && cartData?.idt) {
        if (isJwtTokenExpired(cartData.idt)) {
          console.warn("JWT token (idt) is expired after page became active. Refreshing page to reinitialize.");
          window.location.reload();
        }
      }
    };

    // Listen for visibility changes
    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Cleanup listener on unmount
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartData?.idt, isLoggedIn, locale]);

  // Registered tax verification needs the UCP wrapper before the address is
  // confirmed. The payment element itself remains unmounted until confirmation.
  const canInitializeUcp =
    isBillingAddressConfirmed ||
    (isUcpTaxExemptionLocale && isLoggedIn);

  // Initialize UCP and reinitialize when the in-memory guest token renews.
  useEffect(() => {
    if (
      !cartData ||
      (isPaymentRequired && !canInitializeUcp) ||
      (isPaymentRequired && !isLoggedIn && !guestAccessToken)
    ) {
      return;
    }

    if (isLoggedIn && cartData.idt && isJwtTokenExpired(cartData.idt)) {
      console.warn("JWT token (idt) is expired. Refreshing page to reinitialize.");
      // Refresh the page to reinitialize everything with a fresh token
      window.location.reload();
      return;
    }

    if (isPaymentRequired) {
      // Store initial form values in ref
      formFieldsRef.current = {
        billing: {
          address: formBillingAddress,
          data: formBillingData,
        }
      };
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        paymentSrc: '',
      }));

      const decodedIdToken = cartData.idt && isLoggedIn
        ? jwtDecode<{ nid?: string }>(cartData.idt)
        : null;
      const ncaId = decodedIdToken?.nid;

      const initOptions = buildUcpOptions({
        isGuest: !isLoggedIn,
        guestToken: guestAccessToken,
        registeredToken: cartData.idt,
        ncaId,
        base: {
          environment: getUcpEnvironment(),
          theme: "light" as Theme,
          nonce: uuidv4(),
          locale: localeWith_,
          currency: defaultCurrency.toLowerCase(),
          clientFlavor: "digital",
          version: "v1",
          clientId: "nvstore",
          enableDeviceFingerprint: true,
        },
      });

      let cancelled = false;
      let removeListeners: (() => void) | undefined;
      if (!isLoggedIn) {
        setGuestUcpReady(false);
      }

      initialize(initOptions)
        .then(() => {
          if (cancelled) {
            return;
          }
          setGuestUcpInitializationError(false);
          if (!isLoggedIn) {
            setGuestUcpReady(true);
          }

          const handleGlobalEvent = (event: any) => {
            if (!isLoggedIn) {
              handleUcpGlobalEvent(event);
            }
            if (event.detail?.message === 'DEVICE_FINGERPRINT_REQUEST_UUID') {
              setDeviceFingerprintUuid(event.detail.metadata?.requestUuid);
            }
          };
          const handleRegisteredPayment = (event: any) => {
            if (
              event.detail?.message === PaymentEvents.Exists ||
              event.detail?.message === PaymentEvents.Changed
            ) {
              setEnableReviewOrderBtn(true);
            } else if (event.detail?.message === PaymentEvents.NotExists) {
              setEnableReviewOrderBtn(false);
            }
          };
          const handleGuestPayment = (event: any) => {
            setPaymentEventMessage(event.detail?.message);
            switch (event.detail?.message) {
              case PaymentEvents.Valid:
                setSavePayment(false);
                setEnableReviewOrderBtn(true);
                break;
              default:
                setSavePayment(false);
                setEnableReviewOrderBtn(false);
                break;
            }
          };

          const events = window.Ucp?.events;
          events?.addEventListener('event-global', handleGlobalEvent);
          if (isLoggedIn && cartData.idt) {
            events?.addEventListener(
              "event-registered-user-payment-methods",
              handleRegisteredPayment
            );
          } else {
            events?.addEventListener(
              "event-guest-payment-method",
              handleGuestPayment
            );
          }
          removeListeners = () => {
            events?.removeEventListener('event-global', handleGlobalEvent);
            events?.removeEventListener(
              "event-registered-user-payment-methods",
              handleRegisteredPayment
            );
            events?.removeEventListener(
              "event-guest-payment-method",
              handleGuestPayment
            );
          };
        })
        .catch(() => {
          if (!cancelled && !isLoggedIn) {
            setGuestUcpInitializationError(true);
            setGuestUcpReady(false);
            setEnableReviewOrderBtn(false);
          }
        });

      return () => {
        cancelled = true;
        removeListeners?.();
      };
    } else {
      // The side-effect-free readiness effect below enables zero-dollar orders.
      setEnableReviewOrderBtn(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    cartData,
    defaultCurrency,
    guestAccessToken,
    handleUcpGlobalEvent,
    canInitializeUcp,
    isLoggedIn,
    isPaymentRequired,
    locale,
    localeWith_,
    setDeviceFingerprintUuid,
  ]);

  useEffect(() => {
    if (guestTokenError) {
      setEnableReviewOrderBtn(false);
    }
  }, [guestTokenError]);

  // Handle form state updates based on payment event
  useEffect(() => {
    if (paymentEventMessage === PaymentEvents.Saved && formFieldsRef.current) {
      const { billing } = formFieldsRef.current;

      if (billing.address && billing.data) {
        setFormBillingAddress((prevState) => ({
          ...prevState,
          ...billing.address,
        }));

        setFormBillingData((prevState) => ({
          ...prevState,
          ...billing.data,
        }));
      }
      submitCustomerForm();
      setPaymentEventMessage(null); // Reset the event message
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentEventMessage]);

  // Update ref when form values change
  useEffect(() => {
    if (formBillingAddress && formBillingData) {
      const isEmptyString = (value: any) => {
        return (
          value === undefined ||
          (typeof value === "string" && value.trim() === "")
        );
      };

      const isObjectEmpty = (obj: any) => {
        if (obj === null || obj === undefined || typeof obj !== "object") {
          return isEmptyString(obj);
        }

        for (const key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if (
              !isObjectEmpty(obj[key]) &&
              obj[key] !== undefined &&
              !isEmptyString(obj[key])
            ) {
              return false;
            }
          }
        }
        return true;
      };

      if (
        !isObjectEmpty(formBillingAddress) &&
        !isObjectEmpty(formBillingData)
      ) {
        formFieldsRef.current.billing = {
          address: formBillingAddress,
          data: formBillingData,
        };
      }
    }
  }, [formBillingAddress, formBillingData]);

  // Keep pre-payment CTA readiness side-effect free. Field-level errors are
  // intentionally created by blur handlers, not while another field changes.
  useEffect(() => {
    const isZeroDollarTransaction = cartData?.zdt || cartData?.pricing?.orderTotal?.value === 0;

    if (cartData && (!isBillingAddressConfirmed || isZeroDollarTransaction)) {
      const billingFieldsComplete = Boolean(
        formBillingData.firstNameBilling?.trim() &&
        formBillingData.lastNameBilling?.trim() &&
        formBillingData.contactBilling?.trim() &&
        formBillingData.emailBilling?.trim() &&
        (isLoggedIn ||
          (formBillingData.vemailBilling?.trim() &&
            formBillingData.vemailBilling === formBillingData.emailBilling))
      );
      const addressFieldsComplete = Boolean(
        formBillingAddress.address?.trim() &&
        formBillingAddress.cityValue?.trim() &&
        formBillingAddress.countryValue?.trim() &&
        (!isPostalCodeRequiredForAddress || formBillingAddress.pincode?.trim()) &&
        (!isStateRequiredForAddress || formBillingAddress.stateValue?.trim())
      );
      const blockingFields = [
        "firstNameBilling",
        "lastNameBilling",
        "contactBilling",
        "emailBilling",
        "vemailBilling",
        "address",
        "cityValue",
        "stateValue",
        "pincode",
        "companyName",
        "vatNo",
      ];
      const hasFieldErrors = blockingFields.some(
        (field) => Boolean(validationErrors[field])
      );

      setEnableReviewOrderBtn(
        billingFieldsComplete &&
          addressFieldsComplete &&
          isTaxDataValid() &&
          !hasFieldErrors
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formBillingData, formBillingAddress, formTaxData, isBusinessPurchase, validationErrors, cartData?.zdt, cartData?.pricing?.orderTotal?.value, isBillingAddressConfirmed, isLoggedIn, isPostalCodeRequiredForAddress, isStateRequiredForAddress]);

  useEffect(() => {
    // Ensure selectedBillingAddress is of type iSavedAddress before accessing properties
    if (selectedBillingAddress && selectedBillingAddress !== RESET_ADDRESS) {
      const address = selectedBillingAddress as intrfce.iSavedAddress;
      setFormData((prevData) => ({
        ...prevData,
        iBillingFormData: {
          ...(address.id ? { id: Number(address.id) } : {}),
          firstNameBilling: address.firstName,
          lastNameBilling: address.lastName,
          contactBilling: address.phoneNumber,
          emailBilling: formBillingData.emailBilling,
          vemailBilling: formBillingData.vemailBilling,
        },
        iBillingFormAddress: {
          pincode: address.postalCode,
          address: address.line1,
          line2: address.line2 || "",
          cityValue: address.city,
          stateValue:
            (stateDropdown || locale === 'zh-tw') ? (locale === 'zh-tw' ? "TW" : address.countrySubdivision) : undefined,
          county: countyField ? address.county || "-" : undefined,
          countryValue: address.country,
          countryName: address.countryName,
        }
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        iBillingFormAddress: formBillingAddress,
        iBillingFormData: {
          firstNameBilling: formBillingData.firstNameBilling,
          lastNameBilling: formBillingData.lastNameBilling,
          contactBilling: formBillingData.contactBilling,
          ...(isLoggedIn
            ? { emailBilling: cartData?.emailAddress || "" }
            : { emailBilling: formBillingData.emailBilling || "" }),
          ...(isLoggedIn
            ? { vemailBilling: cartData?.emailAddress || "" }
            : { vemailBilling: formBillingData.emailBilling || "" }),
        }
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validateForm]);

  const isEmptyAddress = (address: any): boolean => {
    if (address) {
      const keysToCheck = [
        "city",
        "country",
        "countryName",
        "countrySubdivision",
        "firstName",
        "isDefault",
        "lastName",
        "line1",
        "line2",
        "nickName",
        "phoneNumber",
        "postalCode",
      ];
      return (
        address.id === -1 &&
        keysToCheck.every(
          (key) =>
            address[key] === "" ||
            address[key] === false ||
            address[key] === null ||
            address[key] === undefined ||
            address[key] === t("ADD_NEW_ADDRESS")
        )
      );
    } else {
      return false;
    }
  };
  useEffect(() => {
    let isNewBillingAddressExists: intrfce.iSavedAddress | undefined;
    let isBillingAddressEmpty: boolean = false;
    let updatedBillingAddresses: intrfce.iSavedAddress[] | undefined;
    let billingAddressArray: intrfce.iSavedAddress[];
    let newBillingAddressId: any;
    let defaultBillingAddress: any;
    let newBillingAddress: any;
    console.log("selectedBillingAddress==>", selectedBillingAddress);
    if (typeof selectedBillingAddress !== "string") {
      isBillingAddressEmpty = isEmptyAddress(selectedBillingAddress);
    }

    if (
      savedBillingAddress &&
      savedBillingAddress.length
    ) {
      billingAddressArray = updatedBillingAddresses?.length
        ? updatedBillingAddresses
        : savedBillingAddress;

      isNewBillingAddressExists = billingAddressArray.find(
        (addr) => Number(addr.id) <= 0
      );
      if (
        typeof selectedBillingAddress === "string") {
        if (typeof selectedBillingAddress === "string") {
          newBillingAddress = {
            id: -1,
            city: "",
            country: "",
            countryName: "",
            ...((stateDropdown || locale === 'zh-tw') && { countrySubdivision: locale === 'zh-tw' ? "TW" : "" }),
            ...(countyField && { county: "" }),
            firstName: "",
            isDefault: true,
            lastName: "",
            line1: "",
            line2: "",
            nickName: t("ADD_NEW_ADDRESS"),
            phoneNumber: "",
            postalCode: "",
          };
          newBillingAddressId = newBillingAddress.id;
          const existingBillingAddress = billingAddressArray.find(
            (addr) => addr.id === -1
          );
          if (!existingBillingAddress) {
            updatedBillingAddresses = [
              newBillingAddress,
              ...savedBillingAddress,
            ];
            setSavedBillingAddress(updatedBillingAddresses);
          } else {
            updatedBillingAddresses = savedBillingAddress;
          }
          setSelectedBillingAddress(newBillingAddress);
        } else {
          if (selectedBillingAddress) {
            newBillingAddressId = selectedBillingAddress["id"];
          }
        }
      } else if (
        cartData &&
        (cartData.billingAddress?.id === -1 ||
          cartData.billingAddress?.id === "0")) {
        if (
          !isNewBillingAddressExists &&
          !isBillingAddressEmpty &&
          !(Number(cartData.billingAddress?.id) > 0)
        ) {
          newBillingAddress = {
            ...cartData.billingAddress,
            id: Number(cartData.billingAddress.id),
            isDefault: false,
            nickName: "Order Address",
            line2: cartData.billingAddress.line2 || "",
            city: cartData.billingAddress.city || "",
            country: cartData.billingAddress.country || "",
            countryName: cartData.billingAddress.countryName || "",
            ...((stateDropdown || locale === 'zh-tw') && {
              countrySubdivision:
                (locale === 'zh-tw' ? "TW" : cartData.billingAddress.countrySubdivision) || "",
            }),
            ...(countyField && {
              county: cartData.billingAddress.county || "",
            }),
            firstName: cartData.billingAddress.firstName || "",
            lastName: cartData.billingAddress.lastName || "",
            line1: cartData.billingAddress.line1 || "",
            phoneNumber: cartData.billingAddress.phoneNumber || "",
            postalCode: cartData.billingAddress.postalCode || "",
          };
          updatedBillingAddresses = [newBillingAddress, ...savedBillingAddress];
          setSavedBillingAddress(updatedBillingAddresses);
          newBillingAddressId = newBillingAddress.id;
        } else {
          if (
            typeof selectedBillingAddress !== "string" &&
            selectedBillingAddress?.id !== Number(cartData.billingAddress.id)
          ) {
            newBillingAddress = billingAddressArray.find(
              (addr) => addr.id === Number(selectedBillingAddress?.id)
            );
          } else {
            newBillingAddress = billingAddressArray.find(
              (addr) => addr.id === Number(cartData.billingAddress?.id)
            );
          }
          if (newBillingAddress && !isBillingAddressEmpty) {
            newBillingAddressId = newBillingAddress.id;
          } else {
            newBillingAddressId = "reset";
          }
        }
      } else if (isBillingAddressEmpty) {
        console.log(selectedBillingAddress);
        if (isBillingAddressEmpty) {
          newBillingAddressId = "reset";
        } else {
          if (typeof selectedBillingAddress !== "string") {
            newBillingAddressId = selectedBillingAddress?.id;
          }
        }
      } else if (
        typeof selectedBillingAddress !== "string" &&
        selectedBillingAddress?.id !== undefined &&
        selectedBillingAddress?.id !== null
      ) {
        if (
          typeof selectedBillingAddress !== "string" &&
          selectedBillingAddress.id === formBillingData?.id
        ) {
          isNewBillingAddressExists = billingAddressArray.find(
            (addr) => Number(addr.id) === selectedBillingAddress?.id
          );
          newBillingAddressId = isNewBillingAddressExists?.id;
        } else {
          newBillingAddressId = selectedBillingAddress?.id;
        }
      } else {
        isNewBillingAddressExists = billingAddressArray.find(
          (addr) => addr.id === Number(cartData?.billingAddress?.id)
        );
        if (!isNewBillingAddressExists) {
          isNewBillingAddressExists = billingAddressArray.find(
            (addr) => addr.id === -1
          );
          if (!isNewBillingAddressExists && selectedBillingAddress) {
            isNewBillingAddressExists = billingAddressArray.find(
              (addr) => addr.id === Number(selectedBillingAddress.id)
            );
          }
        }
        newBillingAddressId = isNewBillingAddressExists?.id;
      }
    }

    // Billing Address Logic
    if (
      savedBillingAddress &&
      savedBillingAddress.length &&
      isLoggedIn
    ) {
      defaultBillingAddress = savedBillingAddress.find(
        (addr) => addr.isDefault
      );
      const billingAddressIdToUse =
        newBillingAddressId !== undefined
          ? newBillingAddressId
          : defaultBillingAddress?.id;
      if (
        billingAddressIdToUse !== undefined &&
        billingAddressIdToUse !== "reset" &&
        typeof selectedBillingAddress !== "string"
      ) {
        handleSavedBillingAddressChange(
          "savedBillingAddress",
          billingAddressIdToUse,
          updatedBillingAddresses
        );
      }
    }

    if (
      savedBillingAddress &&
      savedBillingAddress.length &&
      isLoggedIn
    ) {
      const defaultAddress = savedBillingAddress.find((addr) => addr.isDefault);
      const addressIdToUse =
        newBillingAddressId !== undefined
          ? newBillingAddressId
          : defaultAddress?.id;

      if (
        addressIdToUse !== undefined &&
        addressIdToUse !== "reset" &&
        typeof selectedBillingAddress !== "string" &&
        selectedBillingAddress?.id !== addressIdToUse
      ) {
        handleSavedBillingAddressChange(
          "savedBillingAddress",
          addressIdToUse,
          updatedBillingAddresses
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    savedBillingAddress,
    selectedBillingAddress,
    cartData,
  ]);

  const handleSavedBillingAddressChange = (
    fieldName: string,
    selectedValue: any,
    addrArr?: any
  ) => {
    console.log("handleSavedBillingAddressChange==>", selectedValue);
    if (selectedValue === "reset") {
      setIsBillingReadonly(false);
      setFormBillingAddress({
        pincode: "",
        address: "",
        cityValue: "",
        stateValue: "",
        county: "",
        countryName: countries[0]?.countryName || "",
        countryValue: countries[0]?.ISO_CC || "",
      });
      setFormBillingData({
        firstNameBilling: "",
        lastNameBilling: "",
        contactBilling: "",
        emailBilling: cartData?.emailAddress || "",
        vemailBilling: "",
      });
      if (showBillingCompanyName) {
        setFormTaxData({ companyName: "", vatNo: "" });
      }
      setSelectedBillingAddress(selectedValue);
    } else {
      const addresses = addrArr ? addrArr : savedBillingAddress;
      if (selectedValue < 0) {
        setFormBillingData({
          ...(formBillingData.id ? { id: Number(formBillingData.id) } : {}),
          firstNameBilling: formBillingData?.firstNameBilling || "",
          lastNameBilling: formBillingData?.lastNameBilling || "",
          contactBilling: formBillingData?.contactBilling || "",
          emailBilling:
            cartData?.emailAddress || formBillingData?.emailBilling || "",
          vemailBilling: ""
        });
      } else {
        const selectedAddress = addresses?.filter(
          (bill:any) => bill.id === Number(selectedValue)
        );
        if (selectedAddress) {
          let updatedAddress = selectedAddress[0];
          setSelectedBillingAddress(updatedAddress);
          console.log("handleSavedBillingAddressChange==>", fieldName);
          // Find the selected address based on the nickname
          // Update formBillingAddress with the selected address values
          if (updatedAddress) {
            setFormBillingAddress({
              pincode: updatedAddress?.postalCode || "",
              address: updatedAddress?.line1 || "",
              cityValue: updatedAddress?.city || "",
              stateValue: updatedAddress?.countrySubdivision || "",
              line2: updatedAddress?.line2 || "",
              countryName: updatedAddress?.countryName || "",
              countryValue: updatedAddress?.country || "",
            });
            setFormBillingData({
              ...(updatedAddress.id ? { id: Number(updatedAddress.id) } : {}),
              firstNameBilling: updatedAddress?.firstName || "",
              lastNameBilling: updatedAddress?.lastName || "",
              contactBilling: updatedAddress?.phoneNumber || "",
              emailBilling: cartData?.emailAddress || "",
              vemailBilling: "",
            });
            if (cartData) {
              populateFormTaxDataFromCart(cartData);
            }
            setFormData((prevData) => ({
              ...prevData,
              iBillingFormData: {
                ...prevData.iBillingFormData,
                ...(updatedAddress.id ? { id: Number(updatedAddress.id) } : {}),
                firstNameBilling: updatedAddress?.firstName || "",
                lastNameBilling: updatedAddress?.lastName || "",
                contactBilling: updatedAddress?.phoneNumber || "",
                emailBilling: cartData?.emailAddress || "",
                vemailBilling: "",
              },
              iBillingFormAddress: {
                ...prevData.iBillingFormAddress,
                pincode: updatedAddress?.postalCode || "",
                address: updatedAddress?.line1 || "",
                line2: updatedAddress?.line2 || "",
                cityValue: updatedAddress?.city || "",
                stateValue: updatedAddress?.countrySubdivision || "",
                countryValue: updatedAddress?.country || "",
                countryName: updatedAddress?.countryName || "",
              },
            }));
            if (Number(selectedValue) === 0 || Number(selectedValue) === -1) {
              setIsBillingReadonly(false);
            } else {
              setIsBillingReadonly(isLoggedIn);
            }
            Object.keys(formBillingData).forEach((fieldName) => {
              if (
                formBillingData[fieldName] &&
                formBillingData[fieldName].length
              ) {
                validateForm(fieldName, formBillingData[fieldName]);
              }
            });
            Object.keys(formBillingAddress).forEach((fieldName) => {
              if (
                formBillingAddress[fieldName] &&
                formBillingAddress[fieldName].length
              ) {
                validateForm(
                  fieldName,
                  formBillingAddress[fieldName]
                );
              }
            });
          }
        }
      }
    }
  };

  const handleCartChange = async (
    productId?: string,
    quantity?: number,
    coupon?: string,
    couponApplied?: boolean
  ) => {
    showCartLoader();
    if (productId && quantity === 0) { // Remove item from cart
      await updateCart(
        handleCartUpdateSuccess,
        handleError,
        productId,
        quantity,
        isDownload,
        undefined,
        undefined
      );
    } else if (productId && quantity) {
      await updateCart(
        handleCartUpdateSuccess,
        handleError,
        productId,
        quantity,
        isDownload,
        undefined,
        undefined
      );
    } else {
      if (coupon) {
        await updateCart(
          handleCartUpdateSuccess,
          handleCouponError,
          undefined,
          undefined,
          isDownload,
          coupon,
          undefined,
          false
        );
      } else {
        if (couponApplied) {
          await updateCart(
            handleCartUpdateSuccess,
            handleCouponError,
            undefined,
            undefined,
            isDownload,
            undefined,
            undefined,
            couponApplied
          );
        }
      }
    }
    hideCartLoader();
  };

  const handleCouponChange = (_fieldName: string, promo: string | null) => {
    setCoupon(promo);
    if (promo || promo?.length === 0) {
      setPromoErr(false);
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        promoCode: "",
      }));
    }
    console.log("promo==>", promo);
  };

  const handleCouponDelete = (d: boolean) => {
    handleCartChange(undefined, undefined, undefined, d);
  };
  const handleCouponSubmit = (c: string) => {
    handleCartChange(undefined, undefined, c);
  };

  const buildBillingAddressPayload = (
    billingFormAddress: intrfce.iAddressFormData = formBillingAddress
  ) => {
    const address = {
      ...(formBillingData.id ? { id: Number(formBillingData.id) } : {}),
      firstName: formBillingData.firstNameBilling || "",
      lastName: formBillingData.lastNameBilling || "",
      line1: billingFormAddress.address || "",
      line2: billingFormAddress.line2 || "",
      city: billingFormAddress.cityValue || "",
      countrySubdivision: (stateDropdown || locale === 'zh-tw') ? (locale === 'zh-tw' ? "TW" : billingFormAddress.stateValue) : "",
      county: countyField ? billingFormAddress.county : "",
      postalCode: billingFormAddress.pincode || "",
      country: billingFormAddress.countryValue || "",
      countryName: billingFormAddress.countryName || "",
      emailAddress:
        formBillingData?.emailBilling || cartData?.emailAddress || undefined,
      phoneNumber: formBillingData.contactBilling || "",
    };
    return address;
  };

  const buildCheckoutCart = (billingAddress: ReturnType<typeof buildBillingAddressPayload>) => {
    const cart = {
      futureUse: futureUse,
      billingAddress,
      shippingAddress: billingAddress,
    };
    if (isApTaxExemptionLocale) {
      if (isBusinessPurchase) {
        return {
          ...cart,
          taxExemption: {
            companyName: formTaxData.companyName,
            vatNo: formTaxData.vatNo,
          },
        };
      }
      return cart;
    }

    const companyName = formTaxData.companyName?.trim();
    if (companyName) {
      return {
        ...cart,
        taxExemption: {
          companyName,
          vatNo: null as null,
        },
      };
    }
    return cart;
  };

  useEffect(() => {
    const billingAddress = buildBillingAddressPayload();
    setOrder((prevData) => ({
      ...prevData,
      cart: buildCheckoutCart(billingAddress) as intrfce.iOrderDetails['cart'],
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    formBillingData,
    formBillingAddress,
    formData,
    formTaxData,
    isBusinessPurchase,
  ]);

  // Clear enrollmentErr when isPurchasingForSomeoneElse is true
  useEffect(() => {
    if (isPurchasingForSomeoneElse && validationErrors?.enrollmentErr) {
      setValidationErrors((prevErrors) => {
        const { enrollmentErr, ...rest } = prevErrors;
        return rest;
      });
      setEnableReviewOrderBtn(isPurchasingForSomeoneElse);
    }
  }, [isPurchasingForSomeoneElse, validationErrors?.enrollmentErr]);

  // Check if conflicting product quantity changed to multiple
  useEffect(() => {
    if (cartData && conflictingCourseIds.length > 0 && validationErrors?.enrollmentErr) {
      const cartItems = cartData?.cartItems?.cartItem || [];

      // Check if any conflicting product has quantity > 1
      const hasMultipleQuantity = cartItems.some((item: any) => {
        const almId = item?.product?.alm_id;
        const quantity = item?.quantity || 0;
        return conflictingCourseIds.includes(almId) && quantity > 1;
      });

      if (hasMultipleQuantity) {
        // Clear the enrollment error
        setValidationErrors((prevErrors) => {
          const { enrollmentErr, ...rest } = prevErrors;
          return rest;
        });
        setAddressErr(null);

        // Set isPurchasingForSomeoneElse to true and disable it
        setIsPurchasingForSomeoneElse(true);
        setIsPurchasingDisabled(true);

        // Clear the conflicting course IDs
        setConflictingCourseIds([]);
      }
    }
  }, [cartData, conflictingCourseIds, validationErrors?.enrollmentErr]);

  const handleCartQuantityChange = async (
    productId: number,
    quantity: number
  ) => {
    let pid = productId.toString();
    handleCartChange(pid, quantity);
  };

  const addressRef = useRef<{
    data: intrfce.iAddressFormData | null;
  }>({
    data: null,
  });
  const handleAddressUpdate = (data: any) => {
    console.log("handleAddressUpdate===>", data);
    addressRef.current = { data };
    setBillingAddressOverride(null);
    setFormBillingAddress(data);
    setFormData((prevData) => ({
      ...prevData,
      iBillingFormAddress: data,
    }));
  };

  const handleCartSuccess = (res) => {
    if (res?.paymentSession?.id) {
      sessionStorage.setItem("paymentSession", res?.paymentSession?.id);
    }
    hideBodyLoader();
    reviewOrder(checkoutUserType);
  };

  const handleCartError = (error: any) => {
    hideBodyLoader();

    // Handle error object
    if (error && error.code === "postal_code_invalid") {
      console.error("Postal code invalid:", error.message);
      // Add custom logic for invalid postal code error here (e.g., show specific UI message)
      setAddressErr(error?.description);
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        addressErr: error?.description,
      }));
    } else if (error && error.code === "CRS_ENROLLMENT_FAILED") {
      console.error("Course enrollment failed:", error.message);
      console.log("Description:", error?.description);
      console.log("Conflicts:", error?.conflicts);

      // Handle course enrollment conflict error
      const errorMessage = t('ALREADY_ENROLLED') || error?.description || error?.message || 'User is already enrolled in this course';
      setAddressErr(errorMessage);
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        enrollmentErr: errorMessage,
      }));

      // Store conflicting course IDs
      if (error?.conflicts && error.conflicts.length > 0) {
        const courseIds = error.conflicts;
        setConflictingCourseIds(courseIds);
      }
    } else if (error && error.code === 'SEATS_EXHAUSTED') {
      emptyCart(
        error?.description || error?.message || t("YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY"),
        undefined,
        error
      );
      
    } else if (error && error.message) {
      // Handle other errors
      emptyCart(error.message);
    } else {
      emptyCart(t("YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY"));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  const handleSubmitCart = async (orderDet) => {
    let user: string | null = sessionStorage.getItem("customer");
    if (user && orderDet) {
      sessionStorage.setItem(user, JSON.stringify(orderDet));
    }
    console.log("orderDet==>", orderDet);
    showBodyLoader();
    await submitCart(
      { ...orderDet, locale: locale, brand: brand, isPurchasingForSomeoneElse: isPurchasingForSomeoneElse },
      handleCartSuccess,
      handleCartError
    );
  };

  const submitValidatedBillingAddress = (
    validatedAddress: intrfce.iAddressFormData
  ) => {
    const updatedBillingAddress = buildBillingAddressPayload(validatedAddress);
    if (updatedBillingAddress && !updatedBillingAddress.emailAddress) {
      updatedBillingAddress.emailAddress =
        cartData?.emailAddress || updatedBillingAddress.emailAddress;
    }
    const cartPayload = { cart: buildCheckoutCart(updatedBillingAddress) };
    handleSubmitCart(cartPayload);
  };

  const handleConfirmBillingAddress = () => {
    const confirmedAddress =
      selectedBillingAddressOption === "recommendedAddress"
        ? recommendedBillingAddress
        : formBillingAddress;

    if (
      !confirmedAddress ||
      (selectedBillingAddressOption === "yourAddress" &&
        !isOriginalBillingAddressValid)
    ) {
      return;
    }

    if (selectedBillingAddressOption === "recommendedAddress") {
      setBillingAddressOverride(confirmedAddress);
      setFormBillingAddress(confirmedAddress);
      setFormData((previousData) => ({
        ...previousData,
        iBillingFormAddress: confirmedAddress,
      }));
    }

    setShowBillingAddressModal(false);
    setConfirmedBillingAddressKey(
      getBillingAddressValidationKey(confirmedAddress)
    );

    if (isPaymentRequired) {
      // Payment is initialized only after this confirmation.
      setEnableReviewOrderBtn(false);
    } else {
      submitValidatedBillingAddress(confirmedAddress);
    }
  };

  const validateBillingAddress = async () => {
    if (isAddressValidating) {
      return false;
    }

    if (showBillingCompanyName && formTaxData.companyName?.trim()) {
      validateForm("companyName", formTaxData.companyName);
    }
    if (isApTaxExemptionLocale && isBusinessPurchase) {
      validateForm("companyName", formTaxData.companyName);
      validateForm("vatNo", formTaxData.vatNo || "");
    }
    if (isBillingFormValid() && isBillingAddressValid() && isTaxDataValid()) {
      const addressBeingValidated = { ...formBillingAddress };
      const validationPayload = createBillingAddressValidationPayload(
        addressBeingValidated,
        locale
      );
      let validationResult: any = null;
      let validationFailed = false;

      setIsAddressValidating(true);
      showBodyLoader();
      try {
        await submitAddress(
          validationPayload,
          (result) => {
            validationResult = result;
          },
          () => {
            validationFailed = true;
          }
        );
      } catch (error) {
        validationFailed = true;
      } finally {
        hideBodyLoader();
        setIsAddressValidating(false);
      }

      const validationOutcome = validationFailed
        ? "unavailable"
        : getBillingAddressValidationOutcome(
            validationResult,
            addressBeingValidated
          );
      const originalAddressValid =
        canConfirmEnteredBillingAddress(validationOutcome);
      if (validationOutcome === "unavailable") {
        console.warn(
          "Billing address validation was unavailable; allowing confirmation.",
          { country: addressBeingValidated.countryValue }
        );
      }
      const recommendedAddressCandidate = validationFailed
        ? null
        : getRecommendedBillingAddress(
            validationResult,
            addressBeingValidated
          );
      const recommendedAddress =
        isRecommendedBillingAddressValid(
          validationResult,
          recommendedAddressCandidate
        )
          ? recommendedAddressCandidate
          : null;

      setIsOriginalBillingAddressValid(originalAddressValid);
      setRecommendedBillingAddress(recommendedAddress);
      setSelectedBillingAddressOption("yourAddress");
      setBillingAddressValidationUnavailable(
        isBillingAddressValidationUnavailable(validationOutcome)
      );
      setShowBillingAddressModal(true);
    } else {
      console.log("Form has found missing field values");
      return false;
    }
  };

  const submitCustomerForm = async () => {
    if (!isBillingAddressConfirmed) {
      return validateBillingAddress();
    }

    submitValidatedBillingAddress(formBillingAddress);
  };

  useEffect(() => {
    if (submitAfterSavePayment && savePayment) {
      setSubmitAfterSavePayment(false);
      submitCustomerForm();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitAfterSavePayment, savePayment]);

  const handleFormSubmit = (ev: React.MouseEvent<HTMLButtonElement>) => {
    ev.preventDefault();
    if (!isBillingAddressConfirmed) {
      submitCustomerForm();
      return;
    }

    // Check if this is a zero dollar transaction
    const isZeroDollarTransaction = cartData?.zdt || cartData?.pricing?.orderTotal?.value === 0;

    if (cartData?.isDigital) {
      // For zero dollar transactions, skip payment widget save
      if (isZeroDollarTransaction || savePayment) {
        submitCustomerForm();
      } else {
        ev.preventDefault();
        setSavePayment(true);
        setSubmitAfterSavePayment(true);
        return;
      }
    }
    ev.preventDefault();
    if (
      Object.values(validationErrors).some(
        (error): error is string =>
          typeof error === "string" && error.length > 0
      )
    ) {
      return false;
    } else {
    }
  };

  // Keep the Review Order button in sync with billing/address validity.
  // Payment widget events can enable the button, but they never re-fire when a
  // billing/address field is later cleared, so guard against stale enabled state.
  const billingValidationFields = [
    "firstNameBilling",
    "lastNameBilling",
    "contactBilling",
    "emailBilling",
    "vemailBilling",
    "address",
    "cityValue",
    "stateValue",
    "pincode",
    "companyName",
    "vatNo",
  ];
  const hasBillingValidationErrors = billingValidationFields.some(
    (field) =>
      typeof validationErrors[field] === "string" &&
      validationErrors[field].length > 0
  );

  const coupons = (cartData as any)?.coupons as any[] | undefined;
  const hasNpnPartnerPromotionCoupon = Boolean(
    coupons?.some(
      (coupon: any) => (coupon?.coupon_type || '').toUpperCase() === 'NPN_PARTNER_PROMOTION'
    )
  );
  const canShowPurchaseForSomeoneElseSection =
    !hasNpnPartnerPromotionCoupon &&
    cartData?.category === "ACADEMY" &&
    !cartData?.zdt &&
    cartData?.isDigital;

  return (
    <div className="User">
      <Container>
        <Form className="orderAddressDetails" autoComplete="none" aria-labelledby="orderAddressDetails">
          <Row xs={"auto"} md={"auto"}>
            <Col md={"7"} sm={"auto"} className="w100" role="region" aria-labelledby="cartSectionHeader">
              <Card id="ShoppingCartMobile">
                <div className={isCartLoading ? `cart-loading` : ""} aria-busy={isCartLoading}>
                  {isCartLoading && (
                    <Image
                      src={cartLoader}
                      className="cartLoader"
                      alt="Loading cart"
                    ></Image>
                  )}
                  {cartData && (
                    <Cart
                      onCartChange={handleCartQuantityChange}
                      validationErrors={validationErrors}
                      onPromoChange={handleCouponChange}
                      onPromoSubmit={handleCouponSubmit}
                      onPromoDelete={handleCouponDelete}
                      isThanks={isThanks}
                      isDownload={isDownload}
                      isVerify={isVerify}
                      cartData={cartData}
                      promoCodeError={promoErr}
                      conflicts={conflictingCourseIds}
                    />
                  )}
                </div>
              </Card>
              <div id="newLoginContainer">
                {isLoggedIn && <h1 id="orderAddressDetails">{t("VERIFY_ORDER_HEADER")}</h1>}
                {!isLoggedIn && <h1 id="orderAddressDetails">{t("CHECKOUT_GUEST_BTN")}</h1>}
                {!isLoggedIn && (
                  <p className="dr_loginInstructions">
                    {t("HAVE_AN_ACCOUNT")}{" "}
                    <Button className="continue" onClick={handleLogin}>
                      {t("SITE_LOGIN_PAGE_TITLE")}
                    </Button>
                  </p>
                )}
              </div>
              <h3 id="cartSectionHeader" className="visually-hidden">{t("SHOPPING_CART_HEADER")}</h3>
              {addressErr && (
                <>
                  <p
                    className={`addressErr ${validationErrors.addressErr ? "is-invalid" : ""
                      }`}
                  ></p>
                  <Form.Control.Feedback type="invalid" id="addressErr" aria-live="polite" aria-describedby="addressErr">
                    {validationErrors.addressErr}
                  </Form.Control.Feedback>
                </>
              )}
              <Row xs={"auto"} md={"auto"} className="mb-2" role="region" aria-labelledby="billingDetailsHeader">
                <h3
                  id="billingDetailsHeader"
                  className={`billingDetails ${validationErrors.register ? "is-invalid" : ""}`} >
                  {t("BILLING_ADDRESS")}
                </h3>
                <Form.Control.Feedback type="invalid" id="billingDetailsError" aria-live="polite">
                  {validationErrors.register}
                </Form.Control.Feedback>
              </Row>
              <Row xs={"auto"} md={"auto"} className=" mb-2" role="region" aria-labelledby="billingDetailsForm" id="billingDetailsForm">
                <Col md={6}>
                  {isLoggedIn &&
                    savedBillingAddress &&
                    savedBillingAddress.length > 0 ? (
                    <Form.Group controlId="savedBillingAddress" id="billingAddressSelect" aria-label="Saved Billing Address" role="region" aria-labelledby="billingAddressSelect">
                      {/* Add a visible label for the select, or use aria-label if not possible */}
                      <label htmlFor="savedBillingAddressSelect" className="visually-hidden">
                        Select Billing Address
                      </label>
                      <Form.Select
                        id="savedBillingAddressSelect"
                        autoComplete="none"
                        value={
                          selectedBillingAddress && selectedBillingAddress !== RESET_ADDRESS
                            ? selectedBillingAddress.id
                            : ""
                        }
                        name="savedBillingAddress"
                        aria-label="Select Billing Address" // use only if no visible label
                        aria-required="true" // if this is a required field
                        onChange={(e) =>
                          handleSavedBillingAddressChange(
                            "savedBillingAddress",
                            e.target.value
                          )
                        }
                      >
                        {savedBillingAddress?.map((address, index) => (
                          <option
                            key={address["id"] ?? index}
                            value={address["id"]}
                            selected={address["isDefault"]}
                            aria-selected={address["isDefault"]}
                            aria-label={address["nickName"]}
                            aria-describedby="billingAddressSelect"
                          // Remove selected, React handles it via value on <select>
                          >
                            {address["nickName"]}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  ) : null}
                </Col>
                {isLoggedIn &&
                  savedBillingAddress &&
                  savedBillingAddress.length ? (
                  <Col md={6}>
                    <Button
                      variant="link"
                      className="btn-add pull-right"
                      onClick={() =>
                        handleSavedBillingAddressChange(
                          "savedBillingAddress",
                          RESET_ADDRESS
                        )
                      }
                      aria-label="Add new address"
                      aria-describedby="addNewAddress"
                      aria-live="polite"
                    >
                      <FaPlus /> &nbsp;{t("ADD_NEW_ADDRESS")}
                    </Button>
                    <span id="addNewAddress" className="visually-hidden">
                      {t("ADD_NEW_ADDRESS_DESCRIPTION") || "Add a new billing address to your account"}
                    </span>
                  </Col>
                ) : null}
              </Row>
              <Row xs={"auto"} md={"auto"} className="mb-4">
                {locale !== 'ja-jp' ? (
                  <>
                    <Billing
                      userType={checkoutUserType}
                      onInputChange={handleBillingInputChange}
                      onInputBlur={handleBillingInputBlur}
                      formBillingDetails={formBillingData}
                      validationErrors={validationErrors}
                      isReadOnly={isBillingReadonly}
                      showCompanyName={showBillingCompanyName}
                      companyName={formTaxData.companyName}
                      onCompanyNameChange={(value) =>
                        setFormTaxData((prev) => ({ ...prev, companyName: value }))
                      }
                      onCompanyNameBlur={(value) =>
                        validateForm("companyName", value)
                      }
                      billingUser={
                        selectedBillingAddress
                          ? JSON.stringify(selectedBillingAddress)
                          : ""
                      }
                    />
                    <Places
                      isThanks={isThanks}
                      isDownload={isDigitalProduct}
                      isVerify={isVerify}
                      validationErrors={validationErrors}
                      isBillingReadonly={isBillingReadonly}
                      billingAddr={
                        selectedBillingAddress
                          ? JSON.stringify(selectedBillingAddress)
                          : ""
                      }
                      addressOverride={billingAddressOverride}
                      onPlaceUpdate={(data) => handleAddressUpdate(data)}
                      onFieldBlur={(fieldName, value) =>
                        validateForm(fieldName, value)
                      }
                      brand={brand}
                    />
                  </>
                ) : (
                  <>
                    <BillingJapan
                      userType={checkoutUserType}
                      onInputChange={handleBillingInputChange}
                      onInputBlur={handleBillingInputBlur}
                      formBillingDetails={formBillingData}
                      validationErrors={validationErrors}
                      isReadOnly={isBillingReadonly}
                      showCompanyName={showBillingCompanyName}
                      companyName={formTaxData.companyName}
                      onCompanyNameChange={(value) =>
                        setFormTaxData((prev) => ({ ...prev, companyName: value }))
                      }
                      onCompanyNameBlur={(value) =>
                        validateForm("companyName", value)
                      }
                      billingUser={
                        selectedBillingAddress
                          ? JSON.stringify(selectedBillingAddress)
                          : ""
                      }
                    />
                    <PlacesJapan
                      isThanks={isThanks}
                      isDownload={isDigitalProduct}
                      isVerify={isVerify}
                      validationErrors={validationErrors}
                      isBillingReadonly={isBillingReadonly}
                      billingAddr={
                        selectedBillingAddress
                          ? JSON.stringify(selectedBillingAddress)
                          : ""
                      }
                      onPlaceUpdate={(data) => handleAddressUpdate(data)}
                      onFieldBlur={(fieldName, value) =>
                        validateForm(fieldName, value)
                      }
                    />
                  </>
                )}
              </Row>
              {isUcpTaxExemptionLocale && isLoggedIn && (
                <div className="taxIdentification mb-4">
                  <h3 className={`PaymentHeader`}>{t('TAX_IDENTIFICATION')}</h3>
                  <vat-verification
                    company-name={formTaxData.companyName.trim()}
                    supported-countries={[countryList[0].ISO_CC]}
                    tax-id-required="false"
                  />
                </div>
              )}
              {isUcpTaxExemptionLocale && !isLoggedIn && (
                <div className="taxIdentification mb-4">
                  <h3 className="PaymentHeader">{t("TAX_IDENTIFICATION")}</h3>
                  <p className="taxExemptionLoginPrompt">
                    {t("TAX_EXEMPTION_LOGIN_PROMPT")}
                    <Button className="continue" onClick={handleLogin}>
                      {t("TAX_EXEMPTION_LOGIN_LINK")}
                    </Button>
                    .
                  </p>
                </div>
              )}
              {isApTaxExemptionLocale && (
                <BusinessPurchaseSection
                  isBusinessPurchase={isBusinessPurchase}
                  formTaxData={formTaxData}
                  validationErrors={validationErrors}
                  handleisBusinessPurchaseChange={handleisBusinessPurchaseChange}
                  setFormTaxData={setFormTaxData}
                  t={t}
                />
              )}
              {canShowPurchaseForSomeoneElseSection && (<Row xs={"auto"} md={"auto"} className="mb-2" role="region" aria-labelledby="purchaseTypeHeader">
                <div style={{ display: 'flex', gap: '8px' }}>
                  <h3 id="purchaseTypeHeader" style={{ margin: 0 }}>
                    {t("PURCHASING_FOR_SOMEONE_ELSE")}
                  </h3>
                  <span
                    tabIndex={0}
                    title={t("PURCHASING_FOR_SOMEONE_ELSE_INFO")}
                    aria-label={t("PURCHASING_FOR_SOMEONE_ELSE_INFO")}
                    style={{
                      display: 'inline-block',
                      cursor: 'pointer',
                      fontSize: '-5.9em',
                      outline: 'none'
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 16 16"
                      width="18"
                      height="18"
                      fill="#76b900"
                      aria-hidden="true"
                      focusable="false"
                      style={{ marginLeft: '2px', overflow: 'visible' }}
                    >
                      <g stroke="#76b900" strokeWidth="1.4">
                        <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm0-1A7 7 0 1 1 8 1a7 7 0 0 1 0 14z" fill="#76b900"></path>
                        <path d="M8 11a.5.5 0 0 0 .5-.5v-3A.5.5 0 0 0 8 7a.5.5 0 0 0-.5.5v3A.5.5 0 0 0 8 11zm0-6.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" fill="#76b900"></path>
                      </g>
                    </svg>
                  </span>
                </div>
              </Row>)}
              {canShowPurchaseForSomeoneElseSection && (<Row xs={"auto"} md={"auto"}>
                <Col md={12}>
                  <Form.Group controlId="isPurchasingForSomeoneElse" className="mb-4">
                    <Form.Check
                      type="checkbox"
                      label={t("PURCHASING_FOR_SOMEONE_ELSE_DESCRIPTION")}
                      name="isPurchasingForSomeoneElse"
                      checked={isPurchasingForSomeoneElse}
                      disabled={isPurchasingDisabled}
                      onChange={(e) => setIsPurchasingForSomeoneElse(e.target.checked)}
                    />
                  </Form.Group>
                </Col>
              </Row>)}
              <Row xs={"auto"} md={"auto"} className="mb-2">
                <Col md={12}>
                  {cartData &&
                    !cartData?.zdt &&
                    isBillingAddressConfirmed && (
                    <Payment
                      billingData={selectedBillingAddress}
                      isLoggedIn={isLoggedIn}
                      savePayment={savePayment}
                      validationErrors={validationErrors}
                      formBillingAddress={formBillingAddress}
                      formBillingData={formBillingData}
                    />
                  )}
                </Col>
              </Row>
            </Col>
            <Col md={"5"} sm={"auto"} className="w100">
              <Card id="ShoppingCart">
                <div className={isCartLoading ? `cart-loading` : ""}>
                  {isCartLoading && (
                    <Image
                      src={cartLoader}
                      className="cartLoader"
                      alt="CartLoader"
                    ></Image>
                  )}
                  {cartData && (
                    <Cart
                      onCartChange={handleCartQuantityChange}
                      validationErrors={validationErrors}
                      onPromoChange={handleCouponChange}
                      onPromoSubmit={handleCouponSubmit}
                      onPromoDelete={handleCouponDelete}
                      isThanks={isThanks}
                      isDownload={isDownload}
                      isVerify={isVerify}
                      cartData={cartData}
                      promoCodeError={promoErr}
                      conflicts={conflictingCourseIds}
                    />
                  )}
                </div>
              </Card>
            </Col>
            <Col md={7} sm={12} className="w100 orderReviewCTA d-flex align-items-center">
              <div className="flex-grow-1 d-flex">
                <Button style={{ textTransform: 'capitalize' }} className="continue" onClick={() => window.location.href = config.academyURL}
                  aria-label={t("BTN_CONTINUE_SHOPPING")}>
                  {t("BTN_CONTINUE_SHOPPING")}
                </Button>
              </div>
              <Button
                type="button"
                variant="success"
                className="btn-green orderReviewBtn"
                onClick={handleFormSubmit}
                disabled={
                  !enableReviewOrderBtn ||
                  hasBillingValidationErrors ||
                  guestPaymentUnavailable ||
                  isAddressValidating
                }
                aria-label={t("BTN_REVIEW_ORDER")}
              >
                {isBillingAddressConfirmed || !isPaymentRequired
                  ? t("BTN_REVIEW_ORDER")
                  : t("CONTINUE_TO_PAYMENT", {
                      defaultValue: "Continue to payment",
                    })}
              </Button>
            </Col>
          </Row>
        </Form>
      </Container>
      <BillingAddressValidationModal
        show={showBillingAddressModal}
        address={formBillingAddress}
        recommendedAddress={recommendedBillingAddress}
        selectedOption={selectedBillingAddressOption}
        isOriginalAddressValid={isOriginalBillingAddressValid}
        isStateApplicable={stateDropdown || locale === "en-ap"}
        validationFailed={billingAddressValidationUnavailable}
        onSelectionChange={setSelectedBillingAddressOption}
        onEdit={() => setShowBillingAddressModal(false)}
        onConfirm={handleConfirmBillingAddress}
      />
    </div>
  );
};
export default User;
